import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { login, redirectPath } from "../../../api/helper";
import InsButton from "../../../components/InsButton/InsButton";
import InsHeaderConnect from "../../../components/InsHeaderConnect/InsHeaderConnect";
import InsInput from "../../../components/InsInput/InsInput";
import Validate from "../../../ressources/validation";
import InsCheckbox from "../../../components/InsCheckbox/InsCheckbox";
import ReactGA from "react-ga";
import ReactGA4 from "react-ga4";
import * as microsoftTeams from "@microsoft/teams-js";
import LogoCustomTheme from "components/Theme/Logo/LogoCustomTheme";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      emailError: "",
      passwordError: "",
      rememberMe: false,
    };
  }

  componentDidMount() {
    microsoftTeams.initialize(() => {
      this.props.history.push(`/connect/teams`);
    });
  }

  _connect = () => {
    const { history, t } = this.props;
    const { email, password, rememberMe } = this.state;

    login(email, password, rememberMe).then(
      (data) => {
        history.replace(redirectPath.getRedirectUrl());

        // enseigne
        let enseigne = data.enseign;
        ReactGA.set({ dimension1: enseigne });
        ReactGA4.set({ dimension1: enseigne });

        //Secteur
        let secteur = data.sector;
        ReactGA.set({ dimension2: secteur });
        ReactGA4.set({ dimension2: secteur });
      },
      (data) => {
        console.log(data);
        if (undefined !== data.error && "invalid_grant" === data.error) {
          this.setState({
            passwordError: t("combination_incorrect"),
          });
        } else {
          this.setState({
            passwordError: data,
          });
        }
      }
    );
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  /**
   * Vailde le formulaire de l'étape
   */
  _validateFormStep = () => {
    const { email } = this.state;
    return !Validate("email", email);
  };

  /**
   * Valide le champ email
   */
  _validateEmail = () => {
    const error = Validate("email", this.state.email);
    this.setState({
      emailError: error,
    });
    return !error;
  };

  /**
   * Valide le champ password
   */
  // _validatePassword= () => {
  //     const error = Validate('password', this.state.password);
  //     this.setState({
  //         passwordError: error
  //     })
  //     return !error;
  // }

  continue = (e) => {
    e.preventDefault();
    let valid = true;
    valid = this._validateEmail() && valid;
    if (valid) {
      this._connect();
    }
  };

  rememberMe = () => {
    this.setState({ rememberMe: !this.state.rememberMe });
  };

  render() {
    const { t, auth } = this.props;
    return (
      <div className={`bg-login`}>
        <InsHeaderConnect state={auth} title={t("connection")} />
        <form className="default-container col-flex" name="login-form">
          <div className="mv20">
            <LogoCustomTheme className="we-are-ll" />
          </div>
          <div className="form-container-login">
            <InsInput
              onChange={this.handleChange("email")}
              onBlur={this._validateEmail}
              type="email"
              name="login_mail"
              placeholder={t("email_address")}
              error={this.state.emailError}
            />
            <InsInput
              onChange={this.handleChange("password")}
              onBlur={this._validatePassword}
              type="password"
              name="login_password"
              placeholder={t("password")}
              error={this.state.passwordError}
            />
            <Link to="forget-password" className="forgot-password-link mt20">
              {t("forget_password")}
            </Link>
            <div className="bottom-container">
              <InsCheckbox
                label={t("remember_me")}
                name={t("remember_me")}
                onClick={this.rememberMe}
              />
              <InsButton
                name="login-form--submit"
                text={t("validate")}
                onClick={this.continue}
                disabled={!this._validateFormStep()}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default withTranslation()(Login);
